// MenuItemLink.tsx
import React from 'react';
import { MenuItem } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const MenuItemLink = ({ to, children, ...props }) => {
    return (
        <MenuItem
            component={RouterLink}
            to={to}
            {...props}
        >
            {children}
        </MenuItem>
    );
};

export default MenuItemLink;
